module.exports = __webpack_public_path__ + "statics/img/cate7-3@2x.1da52127.png";